import { apiSlice } from "../api/apiSlice";

export const teamsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTeams: builder.query({
      query: () => "/team",
    }),
    getTeam: builder.query({
      query: (teamId) => `/team/${teamId}`,
    }),
  }),
});

export const { useGetTeamsQuery, useGetTeamQuery } = teamsApi;
